'use client';

import { logger } from '@/lib/default-logger';

function generateToken() {
  const arr = new Uint8Array(12);
  window.crypto.getRandomValues(arr);
  return Array.from(arr, (v) => v.toString(16).padStart(2, '0')).join('');
}

const user = {
  id: 'USR-000',
  avatar: '/assets/avatar.png',
  firstName: 'Sofia',
  lastName: 'Rivers',
  email: 'sofia@devias.io',
};

class AuthClient {
  async signUp(_) {
    // Make API request

    // We do not handle the API, so we'll just generate a token and store it in localStorage.
    const token = generateToken();
    localStorage.setItem('custom-auth-token', token);

    return {};
  }

  async signInWithOAuth(params) {
    return { error: 'Social authentication not implemented' };
  }

  async signInWithPassword(params) {
    const { username, password } = params;
    // logger.debug(JSON.stringify({ username, password }))

    // Make API request

    // We do not handle the API, so we'll check if the credentials match with the hardcoded ones.
    // if (email !== 'sofia@devias.io' || password !== 'Secret1') {
    //   return { error: 'Invalid credentials' };
    // }
    try {
      // const response = await fetch('http://localhost:9300/login', {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
        credentials: 'include', // Include cookies in the request
         // credentials: 'omit', // to avoid cors error?
      });

      logger.debug('login response', response);

      if (!response.ok) {
        const errorData = await response.json();
        return { error: errorData.error };
      }

      const data = await response.json();
      const token = generateToken();
      localStorage.setItem('custom-auth-token', token);
      localStorage.setItem('user', username);
      return { data };
    } catch (error) {
      logger.error('Error during login:', error);
      return { error: 'Error during login' };
    }
  }
    // async signInWithPassword(params) {
    //   const { username, password } = params;
    
    //   try {
    //     const response = await fetch('/api/login', {
    //       method: 'POST',
    //       headers: {
    //         'Content-Type': 'application/json',
    //       },
    //       body: JSON.stringify({ username, password }),
    //       credentials: 'include',
    //     });
    
    //     logger.debug('login response', response);
    
    //     if (!response.ok) {
    //       const errorData = await response.json();
    //       return { error: errorData.error };
    //     }
    
    //     const data = await response.json();
    //     const token = generateToken();
    
    //     // Save user data to localStorage
    //     localStorage.setItem('custom-auth-token', token);
    //     localStorage.setItem('custom-auth-user', JSON.stringify({ username: data.username, email: data.email }));
    
    //     return { data: { username: data.username, email: data.email } };
    //   } catch (error) {
    //     logger.error('Error during login:', error);
    //     return { error: 'Error during login' };
    //   }
    // }

    async checkServerSession() {
      // logger.debug("checkServerSession called");
      try {
        // logger.debug("Attempting to fetch /api/mysessionCheck");
        const response = await fetch('/api/mysessionCheck', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include', 
        });
    
        // logger.debug("Response received:", response.status, response.statusText);
    
        if (!response.ok) {
          // logger.debug("Response not OK");
          return false;
        }
    
        const data = await response.json();
        // logger.debug("Data received:", data);
        return data.valid;
      } catch (error) {
        console.error('Error checking server session:', error);
        return false;
      }
    }
  async resetPassword(_) {
    return { error: 'Password reset not implemented' };
  }

  async updatePassword(_) {
    return { error: 'Update reset not implemented' };
  }
  async getUser() {
    // Make API request

    // We do not handle the API, so just check if we have a token in localStorage.
    const token = localStorage.getItem('custom-auth-token');
    const user = localStorage.getItem('user');
    const sessionTimedout = localStorage.getItem("sessionTimedout") === 'true';
    // logger.debug("shambuu: ", sessionTimedout);
    // logger.debug("token from client: ", token);

    if (!token) {
      return { data: null };
    }
    else if(sessionTimedout){
      // logger.debug("sesion true")
      return { data: null };
    }

    return { data: user };
  }

  
  async signOut() {
    localStorage.removeItem('custom-auth-token');

    return {};
  }
}

export const authClient = new AuthClient();